/**
 * YEŞİLKÖŞE KAFE - CLIENT LOGIC & EVENT PROPOSAL HANDLER
 */

import { store, INITIAL_PRODUCTS } from './store.js';
import { initAdminPanel } from './admin.js';

document.addEventListener('DOMContentLoaded', () => {
  window.store = store;
  window.showToast = showToast;
  window.hardResetStore = () => {
    store.hardReset();
    showToast('🧹 Önhafıza ve State başarıyla temizlendi, güncel veriler yüklendi!');
  };

  handleQRSessionLock();
  initRouter();
  initHeroCarousel();
  initDigitalMenu();
  initEventModule();
  initThemeToggle();
  initMobileMenu();
  initContactForm();
  initModal();
  initFloatingWaiterCall();
  initWifiCopy();
  initSecretAdminTrigger();
  initAdminPanel();
});

/* ==========================================================================
   1. SECURE TABLE AUTHORIZATION & ANTI-SPOOFING LOCK
   ========================================================================== */
async function handleQRSessionLock() {
  const urlParams = new URLSearchParams(window.location.search);
  const tokenParam = urlParams.get('t') || urlParams.get('token');
  const legacyTableParam = urlParams.get('table');

  if (tokenParam) {
    const lockResult = await store.lockTableSession(tokenParam);
    if (lockResult.success) {
      showSecurityNoticeBanner(lockResult.table, true);
      showToast(`🔒 ${lockResult.table.name} güvenli oturumu cihazınıza kilitlendi.`);
    } else {
      showSecurityErrorBanner(lockResult.error);
    }
  } else if (legacyTableParam) {
    const lockResult = await store.lockTableSession(legacyTableParam);
    if (lockResult.success) {
      showSecurityNoticeBanner(lockResult.table, true);
      showToast(`🔒 ${lockResult.table.name} güvenli oturumu cihazınıza kilitlendi.`);
    }
  } else {
    const existingSession = store.getLockedSession();
    if (existingSession) {
      const table = store.findTable ? store.findTable(existingSession.tableId || existingSession.token) : store.tables.find(t => t.id === existingSession.tableId);
      if (table) {
        showSecurityNoticeBanner(table, false);
      }
    }
  }
}


function showSecurityNoticeBanner(table, isNewScan) {
  const area = store.areas.find(a => a.id === table.areaId);
  let banner = document.getElementById('tableNoticeBanner');
  if (!banner) {
    banner = document.createElement('div');
    banner.id = 'tableNoticeBanner';
    banner.className = 'table-notice-banner';
    document.body.prepend(banner);
  }

  banner.innerHTML = `
    <div class="container" style="display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap;">
      <span><i class="ri-shield-check-fill" style="color: var(--gold-hover);"></i> Güvenli Masa Oturumu: <strong>${table.name} (${area ? area.name : ''})</strong></span>
      <div style="display: flex; align-items: center; gap: 8px;">
        <span style="font-size: 0.8rem; background: rgba(255,255,255,0.15); padding: 4px 10px; border-radius: var(--radius-full);">🔒 Cihazınıza Kilitlendi</span>
        <button id="endTableSessionBtn" style="background: rgba(255,255,255,0.22); border: 1px solid rgba(255,255,255,0.3); color: #fff; font-size: 0.76rem; padding: 4px 10px; border-radius: var(--radius-full); cursor: pointer;" title="Kafeden ayrılırken oturumu sonlandır">Masadan Ayrıl ✕</button>
      </div>
    </div>
  `;

  document.getElementById('endTableSessionBtn')?.addEventListener('click', () => {
    store.endLockedSession();
    showToast('👋 Masa oturumunuz sonlandırıldı. Tekrar bekleriz!');
  });
}


function showSecurityErrorBanner(errorMsg) {
  let banner = document.getElementById('tableNoticeBanner');
  if (!banner) {
    banner = document.createElement('div');
    banner.id = 'tableNoticeBanner';
    banner.className = 'table-notice-banner';
    banner.style.background = '#D9534F';
    document.body.prepend(banner);
  }

  banner.innerHTML = `
    <div class="container" style="display: flex; justify-content: space-between; align-items: center;">
      <span><i class="ri-error-warning-fill"></i> Güvenlik Uyarısı: ${errorMsg}</span>
      <span style="font-size: 0.8rem; opacity: 0.8;">Lütfen Masanızdaki QR Kodu Tekrar Taratın</span>
    </div>
  `;
}

/* ==========================================================================
   2. ORGANİZASYON & ETKİNLİK MODÜLÜ HANDLER
   ========================================================================== */
function initEventModule() {
  const eventForm = document.getElementById('eventOfferForm');
  const galleryTabs = document.querySelectorAll('.event-gallery-tab');
  const galleryCards = document.querySelectorAll('.gallery-item-card');
  const guestInput = document.getElementById('eventGuests');
  const areaSelect = document.getElementById('eventArea');
  const capacityHint = document.getElementById('capacityHint');

  const maxCapacities = {
    'kir-bahcesi': 120,
    'kapali-alan': 100,
    'vip-loca': 40
  };

  function checkCapacity() {
    if (!guestInput || !areaSelect || !capacityHint) return;
    const count = Number(guestInput.value) || 0;
    const area = areaSelect.value;
    const maxCap = maxCapacities[area];

    if (maxCap && count > maxCap) {
      capacityHint.style.display = 'block';
      capacityHint.innerHTML = `<i class="ri-alert-line"></i> Seçtiğiniz alanın kapasitesi (maks. ${maxCap} kişi) aşılmıştır. Davetiniz için 'Tüm Mekan / Özel Kiralama' seçeneğini değerlendirebilirsiniz.`;
    } else {
      capacityHint.style.display = 'none';
      capacityHint.innerHTML = '';
    }
  }

  if (guestInput) guestInput.addEventListener('input', checkCapacity);
  if (areaSelect) areaSelect.addEventListener('change', checkCapacity);

  if (eventForm) {
    eventForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = {
        fullName: document.getElementById('eventFullName').value,
        phone: document.getElementById('eventPhone').value,
        eventType: document.getElementById('eventType').value,
        eventArea: document.getElementById('eventArea')?.value || '',
        date: document.getElementById('eventDate').value,
        guests: document.getElementById('eventGuests').value,
        notes: document.getElementById('eventNotes').value
      };

      const newReq = store.addEventRequest(formData);

      // Post asynchronously to Netlify Forms so submissions are permanently stored in Netlify dashboard
      try {
        const netlifyParams = new URLSearchParams();
        netlifyParams.append('form-name', 'organizasyon-teklifleri');
        netlifyParams.append('fullName', formData.fullName);
        netlifyParams.append('phone', formData.phone);
        netlifyParams.append('eventType', formData.eventType);
        netlifyParams.append('eventArea', formData.eventArea);
        netlifyParams.append('date', formData.date);
        netlifyParams.append('guests', formData.guests);
        netlifyParams.append('notes', formData.notes);

        fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: netlifyParams.toString()
        }).catch(err => console.log('Netlify forms background sync:', err));
      } catch (err) {
        console.warn('Netlify form post error:', err);
      }

      eventForm.reset();
      if (capacityHint) capacityHint.style.display = 'none';

      showToast(`🎉 Sayın ${formData.fullName}, organizasyon teklif talebiniz alındı!`);
      openEventOfferSuccessModal(formData);
    });
  }

  galleryTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      galleryTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const filter = tab.getAttribute('data-filter');
      galleryCards.forEach(card => {
        if (filter === 'all' || card.getAttribute('data-category') === filter) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
}

function openEventOfferSuccessModal(formData) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const eventTypeLabels = {
    kina: 'Kına Gecesi',
    nisan: 'Nişan / Söz',
    dogumgunu: 'Doğum Günü Kutlaması',
    sunnet: 'Sünnet Töreni',
    kurumsal: 'Kurumsal Etkinlik / Toplantı',
    diger: 'Özel Davet & Parti'
  };

  const eventAreaLabels = {
    'kir-bahcesi': 'Açık Kır Bahçesi (Maks. 120 Kişi)',
    'kapali-alan': 'Kapalı Alan (Maks. 100 Kişi)',
    'vip-loca': 'VIP Loca (Maks. 40 Kişi)',
    'tum-mekan': 'Tüm Mekan / Özel Kiralama'
  };

  const typeName = eventTypeLabels[formData.eventType] || formData.eventType || 'Özel Organizasyon';
  const areaName = eventAreaLabels[formData.eventArea] || formData.eventArea || 'Belirtilmedi';

  const waText = encodeURIComponent(
    `🎉 *YEŞİLKÖŞE KAFE - ORGANİZASYON TEKLİF TALEBİ*\n\n` +
    `👤 *Ad Soyad:* ${formData.fullName}\n` +
    `📞 *Telefon:* ${formData.phone}\n` +
    `🎊 *Etkinlik Türü:* ${typeName}\n` +
    `📍 *Mekan Tercihi:* ${areaName}\n` +
    `📅 *Tarih:* ${formData.date}\n` +
    `👥 *Tahmini Kişi:* ${formData.guests}\n` +
    (formData.notes ? `📝 *Özel İstek/Not:* ${formData.notes}\n` : '') +
    `\nİyi çalışmalar, detaylı fiyat teklifinizi rica ederim.`
  );

  const waUrl = `https://wa.me/905069701262?text=${waText}`;

  modalBody.innerHTML = `
    <div style="text-align: center; padding: 20px 8px;">
      <div style="width: 64px; height: 64px; border-radius: 50%; background: rgba(46,125,50,0.12); color: #2E7D32; display: flex; align-items: center; justify-content: center; font-size: 2.2rem; margin: 0 auto 16px;">
        <i class="ri-checkbox-circle-fill"></i>
      </div>
      <h3 style="font-size: 1.5rem; color: var(--emerald-dark); margin-bottom: 8px;">Teklif Talebiniz Alındı!</h3>
      <p style="color: var(--text-muted); font-size: 0.95rem; margin-bottom: 20px;">
        Sayın <strong>${formData.fullName}</strong>, organizasyon talebiniz işletmemize iletildi.
      </p>

      <div style="background: rgba(19,75,59,0.04); border: 1px dashed var(--emerald-main); border-radius: var(--radius-sm); padding: 16px; margin-bottom: 24px; text-align: left; font-size: 0.9rem; line-height: 1.6;">
        <div><strong>👤 Ad Soyad:</strong> ${formData.fullName}</div>
        <div><strong>📞 Telefon:</strong> ${formData.phone}</div>
        <div><strong>🎊 Etkinlik:</strong> ${typeName}</div>
        <div><strong>📍 Tercih Edilen Alan:</strong> ${areaName}</div>
        <div><strong>📅 Tarih & Kişi:</strong> ${formData.date} (${formData.guests} Kişi)</div>
        ${formData.notes ? `<div><strong>📝 Not:</strong> ${formData.notes}</div>` : ''}
      </div>

      <div style="display: flex; flex-direction: column; gap: 12px;">
        <a href="${waUrl}" target="_blank" rel="noopener" class="btn btn-accent" style="padding: 14px; font-size: 1rem; font-weight: 700; text-decoration: none; display: flex; align-items: center; justify-content: center; gap: 8px; background: #25D366; border-color: #25D366; color: #fff;">
          <i class="ri-whatsapp-line" style="font-size: 1.4rem;"></i> Talebi WhatsApp ile İlet (Anında Dönüş)
        </a>
        <button type="button" class="btn btn-outline" id="closeEventOfferSuccessBtn">
          Pencereyi Kapat
        </button>
      </div>
    </div>
  `;

  backdrop.classList.add('active');
  document.getElementById('closeEventOfferSuccessBtn')?.addEventListener('click', () => {
    backdrop.classList.remove('active');
  });
}

/* ==========================================================================
   3. SPA ROUTER & NAVIGATION
   ========================================================================== */
function initRouter() {
  function handleRoute() {
    let rawHash = window.location.hash || '';
    // Strip query parameters if appended to hash, e.g. #secret-admin-gate?v=105 -> #secret-admin-gate
    const hash = rawHash.split('?')[0].trim();

    const pages = document.querySelectorAll('.page-view');
    const navLinks = document.querySelectorAll('.nav-link');

    pages.forEach(p => p.style.display = 'none');
    navLinks.forEach(l => l.classList.remove('active'));

    if (hash === '#secret-admin-gate' || hash === '#admin') {
      const adminView = document.getElementById('page-admin');
      if (adminView) adminView.style.display = 'block';
      const activeLink = document.querySelector('.nav-link[href="#secret-admin-gate"]');
      if (activeLink) activeLink.classList.add('active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (hash === '#organizasyonlar' || hash === '#organizasyon' || hash === '#etkinlik' || hash === '#teklif-al') {
      const orgView = document.getElementById('page-organizasyon');
      if (orgView) orgView.style.display = 'block';
      const activeLink = document.querySelector('.nav-link[href="#organizasyonlar"]');
      if (activeLink) activeLink.classList.add('active');

      if (hash === '#teklif-al') {
        const teklifElem = document.getElementById('teklif-al');
        if (teklifElem) teklifElem.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else if (hash === '#menu' || hash === '#features' || hash === '#contact') {
      const homeView = document.getElementById('page-home');
      if (homeView) homeView.style.display = 'block';

      const scrollTarget = document.getElementById(hash.substring(1));
      if (scrollTarget) {
        setTimeout(() => scrollTarget.scrollIntoView({ behavior: 'smooth' }), 100);
      }
      const activeLink = document.querySelector(`.nav-link[href="${hash}"]`);
      if (activeLink) activeLink.classList.add('active');
    } else {
      const homeView = document.getElementById('page-home');
      if (homeView) homeView.style.display = 'block';

      const homeLink = document.querySelector('.nav-link[href="#home"]') || document.querySelector('.nav-link[href="/"]');
      if (homeLink) homeLink.classList.add('active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  window.addEventListener('hashchange', handleRoute);
  handleRoute();
}

/* ==========================================================================
   4. HERO CAROUSEL
   ========================================================================== */
function initHeroCarousel() {
  const slides = document.querySelectorAll('.slide');
  const dotsContainer = document.querySelector('.carousel-nav');
  if (!slides.length || !dotsContainer) return;

  let currentSlide = 0;
  let slideInterval;

  dotsContainer.innerHTML = '';
  slides.forEach((_, idx) => {
    const dot = document.createElement('button');
    dot.className = `carousel-dot ${idx === 0 ? 'active' : ''}`;
    dot.setAttribute('aria-label', `Slide ${idx + 1}`);
    dot.addEventListener('click', () => goToSlide(idx));
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll('.carousel-dot');

  function goToSlide(index) {
    slides[currentSlide].classList.remove('active');
    dots[currentSlide].classList.remove('active');

    currentSlide = (index + slides.length) % slides.length;

    slides[currentSlide].classList.add('active');
    dots[currentSlide].classList.add('active');
  }

  function startAutoplay() {
    slideInterval = setInterval(() => {
      goToSlide(currentSlide + 1);
    }, 5000);
  }

  function stopAutoplay() {
    clearInterval(slideInterval);
  }

  const carouselElem = document.querySelector('.hero-carousel');
  if (carouselElem) {
    carouselElem.addEventListener('mouseenter', stopAutoplay);
    carouselElem.addEventListener('mouseleave', startAutoplay);
  }

  startAutoplay();
}

/* ==========================================================================
   5. DIGITAL MENU WITH OUT-OF-STOCK CHECKS
   ========================================================================== */
let menuOrderMode = 'table'; // 'table' or 'takeaway'

function initDigitalMenu() {
  const menuGrid = document.getElementById('menuGrid');
  const searchInput = document.getElementById('menuSearchInput');
  const categoryTabs = document.querySelectorAll('.category-tab');
  const modeTableBtn = document.getElementById('modeTableBtn');
  const modeTakeawayBtn = document.getElementById('modeTakeawayBtn');
  const btnOpenCartModal = document.getElementById('btnOpenCartModal');

  if (!menuGrid) return;

  let activeCategory = 'Sıcak İçecekler';
  let searchQuery = '';

  if (modeTableBtn && modeTakeawayBtn) {
    modeTableBtn.addEventListener('click', () => {
      menuOrderMode = 'table';
      modeTableBtn.classList.add('active');
      modeTakeawayBtn.classList.remove('active');
      renderMenu();
      updateFloatingCartBar();
    });

    modeTakeawayBtn.addEventListener('click', () => {
      menuOrderMode = 'takeaway';
      modeTakeawayBtn.classList.add('active');
      modeTableBtn.classList.remove('active');
      renderMenu();
      updateFloatingCartBar();
    });
  }

  if (btnOpenCartModal) {
    btnOpenCartModal.addEventListener('click', () => {
      openCartModal();
    });
  }

  function updateFloatingCartBar() {
    const floatingCartBar = document.getElementById('floatingCartBar');
    const orderModeToggleWrap = document.getElementById('orderModeToggleWrap');
    const cartItemCount = document.getElementById('cartItemCount');
    const cartTotalPrice = document.getElementById('cartTotalPrice');

    if (orderModeToggleWrap) {
      orderModeToggleWrap.style.display = store.isOrderingEnabled ? 'flex' : 'none';
    }

    if (!floatingCartBar) return;

    if (!store.isOrderingEnabled) {
      floatingCartBar.style.display = 'none';
      return;
    }

    const count = store.getCartCount();
    const total = store.getCartTotal();

    if (cartItemCount) cartItemCount.textContent = count;
    if (cartTotalPrice) cartTotalPrice.textContent = `₺${total.toFixed(2)}`;

    if (menuOrderMode === 'takeaway' || count > 0) {
      floatingCartBar.style.display = 'flex';
    } else {
      floatingCartBar.style.display = 'none';
    }
  }

  function renderMenu() {
    menuGrid.innerHTML = '';
    const products = (store.products && store.products.length > 0) ? store.products : INITIAL_PRODUCTS;
    const cart = store.getCart();

    const filtered = products.filter(item => {
      const matchesCat = activeCategory === 'all' || 
                         item.category === activeCategory || 
                         (activeCategory === 'Sıcak İçecekler' && (item.category === 'hot-drinks' || item.category === 'Sıcak İçecekler')) ||
                         (activeCategory === 'Soğuk İçecekler' && (item.category === 'ice-coffee' || item.category === 'Soğuk İçecekler')) ||
                         (activeCategory === 'Tatlılar' && (item.category === 'dessert' || item.category === 'Tatlılar')) ||
                         (activeCategory === 'Kahvaltılıklar' && (item.category === 'breakfast' || item.category === 'Kahvaltılıklar'));
      const q = searchQuery.toLowerCase();
      const matchesName = item.name ? item.name.toLowerCase().includes(q) : false;
      const matchesDesc = item.desc ? item.desc.toLowerCase().includes(q) : false;
      const matchesTags = Array.isArray(item.tags)
        ? item.tags.some(t => t.toLowerCase().includes(q))
        : (item.tag ? item.tag.toLowerCase().includes(q) : false);

      return matchesCat && (matchesName || matchesDesc || matchesTags);
    });

    if (filtered.length === 0) {
      menuGrid.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 48px; color: var(--text-muted);">
          <i class="ri-search-eye-line" style="font-size: 3rem; display: block; margin-bottom: 12px;"></i>
          Aradığınız kritere uygun lezzet bulunamadı.
        </div>
      `;
      return;
    }

    filtered.forEach(item => {
      const card = document.createElement('div');
      card.className = `menu-item-card ${item.isOutOfStock ? 'is-out-of-stock' : ''}`;
      
      const tagsHtml = Array.isArray(item.tags)
        ? item.tags.map(t => `<span class="tag">${t}</span>`).join(' ')
        : `<span class="tag">${item.tag || ''}</span>`;

      const imgSrc = item.imageUrl || item.image || './src/assets/images/hero-coffee.jpg';
      const priceDisplay = item.price > 0 ? `₺${item.price.toFixed(2)}` : 'Ücretsiz / İkram';

      const cartItems = cart.filter(c => c.id == item.id);
      const totalQtyInCart = cartItems.reduce((s, c) => s + c.qty, 0);

      let actionButtonHtml = '';
      if (store.isOrderingEnabled) {
        if (menuOrderMode === 'takeaway') {
          if (totalQtyInCart > 0) {
            actionButtonHtml = `
              <div class="cart-stepper">
                <button class="cart-step-btn btn-cart-minus" data-id="${item.id}" title="Azalt">-</button>
                <span class="cart-step-qty">${totalQtyInCart}</span>
                <button class="cart-step-btn btn-cart-plus" data-id="${item.id}" title="Artır" ${item.isOutOfStock ? 'disabled' : ''}>+</button>
              </div>
            `;
          } else {
            actionButtonHtml = `
              <button class="btn btn-accent add-to-cart-btn" data-id="${item.id}" ${item.isOutOfStock ? 'disabled' : ''}>
                <i class="ri-shopping-cart-2-line"></i> ${item.isOutOfStock ? 'Tükendi' : 'Sepete Ekle'}
              </button>
            `;
          }
        } else {
          actionButtonHtml = `
            <button class="btn btn-outline order-btn" style="padding: 6px 14px; font-size: 0.8rem;" data-id="${item.id}" ${item.isOutOfStock ? 'disabled' : ''}>
              <i class="ri-shopping-bag-line"></i> ${item.isOutOfStock ? 'Tükendi' : 'Sipariş Ver'}
            </button>
          `;
        }
      }

      card.innerHTML = `
        <div style="position: relative;">
          <img src="${imgSrc}" alt="${item.name}" class="menu-item-img" loading="lazy" onerror="this.onerror=null;this.src='./src/assets/images/hero-coffee.jpg';">
          ${item.isOutOfStock ? `<span class="out-of-stock-badge">TÜKENDİ</span>` : ''}
        </div>
        <div class="menu-item-body">
          <div class="menu-item-header">
            <h4 class="menu-item-title">${item.name}</h4>
            <span class="menu-item-price">${priceDisplay}</span>
          </div>
          <p class="menu-item-desc">${item.desc || ''}</p>
          <div class="menu-item-footer">
            <div style="display: flex; gap: 4px; flex-wrap: wrap;">${tagsHtml}</div>
            ${actionButtonHtml}
          </div>
        </div>
      `;
      menuGrid.appendChild(card);
    });

    menuGrid.querySelectorAll('.order-btn:not([disabled])').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const itemId = e.currentTarget.getAttribute('data-id');
        const selectedItem = products.find(i => i.id == itemId);
        if (selectedItem) openOrderModal(selectedItem);
      });
    });

    menuGrid.querySelectorAll('.add-to-cart-btn:not([disabled])').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const itemId = e.currentTarget.getAttribute('data-id');
        const selectedItem = products.find(i => i.id == itemId);
        if (selectedItem) {
          if (selectedItem.options && selectedItem.options.choices && selectedItem.options.choices.length > 0) {
            openTakeawayOptionModal(selectedItem);
          } else {
            store.addToCart(selectedItem.id, 1);
            showToast(`🛒 ${selectedItem.name} sepete eklendi!`);
            renderMenu();
            updateFloatingCartBar();
          }
        }
      });
    });

    menuGrid.querySelectorAll('.btn-cart-plus:not([disabled])').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const itemId = e.currentTarget.getAttribute('data-id');
        store.addToCart(itemId, 1);
        renderMenu();
        updateFloatingCartBar();
      });
    });

    menuGrid.querySelectorAll('.btn-cart-minus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const itemId = e.currentTarget.getAttribute('data-id');
        const cart = store.getCart();
        const cartItem = cart.find(c => c.id == itemId);
        if (cartItem) {
          store.updateCartQty(cartItem.id, cartItem.selectedOption, cartItem.qty - 1);
          renderMenu();
          updateFloatingCartBar();
        }
      });
    });

    updateFloatingCartBar();
  }

  categoryTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      categoryTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      activeCategory = tab.getAttribute('data-category');
      renderMenu();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value;
      renderMenu();
    });
  }

  window.addEventListener('store-update', () => {
    renderMenu();
    updateFloatingCartBar();
  });
  renderMenu();
  updateFloatingCartBar();
}

function openTakeawayOptionModal(item) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const choices = item.options.choices || [];
  modalBody.innerHTML = `
    <h3 style="margin-bottom: 8px; font-size: 1.4rem; color: var(--emerald-dark);">${item.name}</h3>
    <p style="color: var(--text-muted); font-size: 0.9rem; margin-bottom: 16px;">Lütfen tercihinizi seçiniz:</p>

    <form id="takeawayOptionForm">
      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label">${item.options.title}</label>
        <select id="optionChoiceSelect" class="form-input" required>
          ${choices.map(c => `<option value="${c}">${c}</option>`).join('')}
        </select>
      </div>
      <button type="submit" class="btn btn-accent w-100" style="width: 100%;">
        <i class="ri-shopping-cart-2-line"></i> Sepete Ekle (₺${item.price.toFixed(2)})
      </button>
    </form>
  `;
  backdrop.classList.add('active');

  document.getElementById('takeawayOptionForm')?.addEventListener('submit', (e) => {
    e.preventDefault();
    const opt = document.getElementById('optionChoiceSelect').value;
    store.addToCart(item.id, 1, opt);
    backdrop.classList.remove('active');
    showToast(`🛒 ${item.name} (${opt}) sepete eklendi!`);
  });
}

function openCartModal() {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const cart = store.getCart();
  const total = store.getCartTotal();

  if (cart.length === 0) {
    modalBody.innerHTML = `
      <div style="text-align: center; padding: 32px 16px;">
        <i class="ri-shopping-cart-line" style="font-size: 3.5rem; color: var(--text-muted); display: block; margin-bottom: 12px;"></i>
        <h3 style="font-size: 1.4rem; color: var(--emerald-dark); margin-bottom: 8px;">Sepetiniz Boş</h3>
        <p style="color: var(--text-muted); font-size: 0.9rem; margin-bottom: 24px;">Menüden lezzetli ürünleri seçerek sepetinize ekleyebilirsiniz.</p>
        <button class="btn btn-primary" onclick="document.getElementById('modalBackdrop').classList.remove('active');">
          Menüyü İncele
        </button>
      </div>
    `;
    backdrop.classList.add('active');
    return;
  }

  const itemsHtml = cart.map(item => `
    <div class="cart-modal-item">
      <div style="flex: 1;">
        <div style="font-weight: 700; color: var(--emerald-dark); font-size: 0.95rem;">${item.displayName || item.name}</div>
        <div style="font-weight: 800; color: var(--gold-accent); font-size: 0.9rem;">₺${(item.price * item.qty).toFixed(2)} <span style="font-size: 0.75rem; color: var(--text-muted); font-weight: normal;">(₺${item.price.toFixed(2)} / ad.)</span></div>
      </div>
      <div class="cart-stepper" style="margin: 0 12px;">
        <button class="cart-step-btn btn-cart-modal-minus" data-id="${item.id}" data-opt="${item.selectedOption || ''}">-</button>
        <span class="cart-step-qty">${item.qty}</span>
        <button class="cart-step-btn btn-cart-modal-plus" data-id="${item.id}" data-opt="${item.selectedOption || ''}">+</button>
      </div>
      <button class="btn-cart-modal-remove" data-id="${item.id}" data-opt="${item.selectedOption || ''}" title="Sil"><i class="ri-delete-bin-line"></i></button>
    </div>
  `).join('');

  modalBody.innerHTML = `
    <h3 style="margin-bottom: 16px; font-size: 1.5rem; color: var(--emerald-dark); display: flex; align-items: center; justify-content: space-between;">
      <span>🛵 Sepetim ve Sipariş Tamamlama</span>
      <span style="font-size: 1.1rem; color: var(--gold-accent); font-weight: 800;">₺${total.toFixed(2)}</span>
    </h3>

    <div class="cart-modal-items-list" style="max-height: 200px; overflow-y: auto; margin-bottom: 20px; border: 1px solid var(--border-light); border-radius: var(--radius-sm); padding: 12px; background: rgba(19,75,59,0.02);">
      ${itemsHtml}
    </div>

    <form id="checkoutForm">
      <div class="form-group" style="margin-bottom: 14px;">
        <label class="form-label" style="font-weight: 700;">Sipariş / Teslimat Türü</label>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
          <label class="takeaway-type-option active" id="lblDelivery">
            <input type="radio" name="orderType" value="delivery" checked style="display:none;">
            <i class="ri-e-bike-2-line"></i> Eve Teslimat (Paket)
          </label>
          <label class="takeaway-type-option" id="lblPickup">
            <input type="radio" name="orderType" value="pickup" style="display:none;">
            <i class="ri-store-2-line"></i> Gel-Al (Mekandan)
          </label>
        </div>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px;">
        <div class="form-group">
          <label class="form-label">Adınız Soyadınız *</label>
          <input type="text" id="takeawayName" class="form-input" placeholder="Örn: Ahmet Yılmaz" required>
        </div>
        <div class="form-group">
          <label class="form-label">Telefon Numarası *</label>
          <input type="tel" id="takeawayPhone" class="form-input" placeholder="0506 000 00 00" required>
        </div>
      </div>

      <div class="form-group" id="addressGroup" style="margin-bottom: 12px;">
        <label class="form-label">Teslimat Adresi (Bina, Daire, Tarif) *</label>
        <textarea id="takeawayAddress" class="form-textarea" rows="2" placeholder="Örn: Alsancak Mah. 2205 Sk. No:14 D:3 Etimesgut/Ankara" required></textarea>
      </div>

      <div class="form-group" id="pickupGroup" style="margin-bottom: 12px; display: none;">
        <label class="form-label">Tahmini Gel-Al Saati / Dakikası *</label>
        <input type="text" id="takeawayPickupTime" class="form-input" placeholder="Örn: 20 Dakika sonra geleceğim">
      </div>

      <div class="form-group" style="margin-bottom: 12px;">
        <label class="form-label">Sipariş Notu (İsteğe Bağlı)</label>
        <input type="text" id="takeawayNotes" class="form-input" placeholder="Örn: Zili çalmayın bebek uyuyor, soslar ayrı olsun...">
      </div>

      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label" style="font-weight: 700;">Ödeme Yöntemi Tercihi *</label>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
          <label class="payment-method-option active" id="lblCard">
            <input type="radio" name="paymentMethod" value="credit_card" checked style="display:none;">
            💳 Kapıda Kredi Kartı
          </label>
          <label class="payment-method-option" id="lblCash">
            <input type="radio" name="paymentMethod" value="cash" style="display:none;">
            💵 Kapıda Nakit
          </label>
        </div>
      </div>

      <button type="submit" class="btn btn-accent w-100" style="width: 100%; padding: 14px; font-size: 1rem; font-weight: 800;">
        <i class="ri-check-double-line"></i> Siparişi Gönder (₺${total.toFixed(2)})
      </button>
    </form>
  `;

  backdrop.classList.add('active');

  const radiosOrderType = document.querySelectorAll('input[name="orderType"]');
  radiosOrderType.forEach(radio => {
    radio.addEventListener('change', (e) => {
      document.querySelectorAll('.takeaway-type-option').forEach(l => l.classList.remove('active'));
      const val = e.target.value;
      if (val === 'delivery') {
        document.getElementById('lblDelivery').classList.add('active');
        document.getElementById('addressGroup').style.display = 'block';
        document.getElementById('takeawayAddress').required = true;
        document.getElementById('pickupGroup').style.display = 'none';
        document.getElementById('takeawayPickupTime').required = false;
      } else {
        document.getElementById('lblPickup').classList.add('active');
        document.getElementById('addressGroup').style.display = 'none';
        document.getElementById('takeawayAddress').required = false;
        document.getElementById('pickupGroup').style.display = 'block';
        document.getElementById('takeawayPickupTime').required = true;
      }
    });
  });

  const radiosPayment = document.querySelectorAll('input[name="paymentMethod"]');
  radiosPayment.forEach(radio => {
    radio.addEventListener('change', (e) => {
      document.querySelectorAll('.payment-method-option').forEach(l => l.classList.remove('active'));
      if (e.target.value === 'credit_card') {
        document.getElementById('lblCard').classList.add('active');
      } else {
        document.getElementById('lblCash').classList.add('active');
      }
    });
  });

  modalBody.querySelectorAll('.btn-cart-modal-plus').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.getAttribute('data-id');
      const opt = e.currentTarget.getAttribute('data-opt') || null;
      const item = store.getCart().find(i => i.id == id && (i.selectedOption || null) === opt);
      if (item) {
        store.updateCartQty(id, opt, item.qty + 1);
        openCartModal();
      }
    });
  });

  modalBody.querySelectorAll('.btn-cart-modal-minus').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.getAttribute('data-id');
      const opt = e.currentTarget.getAttribute('data-opt') || null;
      const item = store.getCart().find(i => i.id == id && (i.selectedOption || null) === opt);
      if (item) {
        store.updateCartQty(id, opt, item.qty - 1);
        openCartModal();
      }
    });
  });

  modalBody.querySelectorAll('.btn-cart-modal-remove').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.getAttribute('data-id');
      const opt = e.currentTarget.getAttribute('data-opt') || null;
      store.removeFromCart(id, opt);
      openCartModal();
    });
  });

  document.getElementById('checkoutForm')?.addEventListener('submit', (e) => {
    e.preventDefault();

    const orderType = document.querySelector('input[name="orderType"]:checked')?.value || 'delivery';
    const customerName = document.getElementById('takeawayName').value.trim();
    const phone = document.getElementById('takeawayPhone').value.trim();
    const address = orderType === 'delivery'
      ? document.getElementById('takeawayAddress').value.trim()
      : document.getElementById('takeawayPickupTime').value.trim();
    const orderNote = document.getElementById('takeawayNotes').value.trim();
    const paymentMethod = document.querySelector('input[name="paymentMethod"]:checked')?.value || 'credit_card';

    const orderData = {
      orderType,
      customerName,
      phone,
      address,
      orderNote,
      paymentMethod,
      items: cart.map(i => ({ id: i.id, name: i.displayName || i.name, price: i.price, qty: i.qty })),
      total: total
    };

    const createdOrder = store.addOnlineOrder(orderData);

    const itemsListStr = cart.map(i => `• ${i.qty}x ${i.displayName || i.name} (₺${(i.price * i.qty).toFixed(2)})`).join('\n');
    const typeStr = orderType === 'delivery' ? '🛵 Eve Teslimat (Paket Servis)' : '🛍️ Gel-Al (Mekandan Teslim)';
    const payStr = paymentMethod === 'credit_card' ? 'Kapıda Kredi Kartı' : 'Kapıda Nakit';

    const waText = encodeURIComponent(
      `🎉 *YEŞİLKÖŞE KAFE ONLİNE SİPARİŞ (${createdOrder.id})*\n\n` +
      `👤 *Müşteri:* ${customerName}\n` +
      `📞 *Telefon:* ${phone}\n` +
      `📍 *Tür & Teslimat:* ${typeStr}\n` +
      `🏠 *Adres/Not:* ${address}\n` +
      `💳 *Ödeme:* ${payStr}\n` +
      (orderNote ? `📝 *Sipariş Notu:* ${orderNote}\n` : '') +
      `\n🛒 *Ürünler:*\n${itemsListStr}\n\n` +
      `💰 *Toplam Tutar:* ₺${total.toFixed(2)}`
    );

    const waUrl = `https://wa.me/905069701262?text=${waText}`;

    modalBody.innerHTML = `
      <div style="text-align: center; padding: 24px 12px;">
        <div style="width: 72px; height: 72px; border-radius: 50%; background: rgba(46,125,50,0.15); color: #2E7D32; display: flex; align-items: center; justify-content: center; font-size: 2.5rem; margin: 0 auto 16px;">
          <i class="ri-checkbox-circle-fill"></i>
        </div>
        <h3 style="font-size: 1.6rem; color: var(--emerald-dark); margin-bottom: 8px;">Siparişiniz Başarıyla Alındı!</h3>
        <p style="color: var(--text-muted); font-size: 0.95rem; margin-bottom: 20px;">
          Sipariş kodunuz: <strong style="color: var(--gold-accent); font-size: 1.1rem;">${createdOrder.id}</strong>. İşletmemiz siparişinizi hazırlamaya başladı.
        </p>

        <div style="background: rgba(19,75,59,0.04); border: 1px dashed var(--emerald-main); border-radius: var(--radius-sm); padding: 16px; margin-bottom: 24px; text-align: left;">
          <div style="font-weight: 700; color: var(--emerald-dark); margin-bottom: 6px;"><i class="ri-information-line"></i> Sipariş Özeti:</div>
          <div style="font-size: 0.9rem; color: var(--text-dark);">${typeStr} - <strong>₺${total.toFixed(2)}</strong> (${payStr})</div>
          <div style="font-size: 0.85rem; color: var(--text-muted); margin-top: 4px;">Adres/Teslimat: ${address}</div>
        </div>

        <div style="display: flex; flex-direction: column; gap: 10px;">
          <a href="${waUrl}" target="_blank" rel="noopener" class="btn btn-accent" style="padding: 12px; font-weight: 700; text-decoration: none; display: flex; align-items: center; justify-content: center; gap: 8px; background: #25D366; border-color: #25D366; color: #fff;">
            <i class="ri-whatsapp-line" style="font-size: 1.3rem;"></i> WhatsApp ile İletişime Geç (İsteğe Bağlı)
          </a>
          <button class="btn btn-primary" onclick="document.getElementById('modalBackdrop').classList.remove('active');">
            Tamam, Ana Sayfaya Dön
          </button>
        </div>
      </div>
    `;

    showToast(`🎉 Paket siparişiniz başarıyla alındı! (Kod: ${createdOrder.id})`);
  });
}

/* ==========================================================================
   6. FLOATING WAITER CALL BUTTON (VERIFIED ONLY)
   ========================================================================== */
function initFloatingWaiterCall() {
  const callBtn = document.getElementById('floatingCallBtn');
  if (!callBtn) return;

  callBtn.addEventListener('click', () => {
    openCallModal();
  });
}

function openCallModal() {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const session = store.getLockedSession();

  if (!session) {
    modalBody.innerHTML = `
      <div style="text-align: center; padding: 20px 0;">
        <i class="ri-qr-scan-2-line" style="font-size: 3.5rem; color: #D9534F; display: block; margin-bottom: 12px;"></i>
        <h3 style="font-size: 1.4rem; color: var(--emerald-dark); margin-bottom: 8px;">QR Oturumu Gerekli</h3>
        <p style="color: var(--text-muted); font-size: 0.9rem; margin-bottom: 24px;">
          Güvenlik gereği garson veya hesap çağırmak için masanızdaki QR kodu cihazınızla taratmanız gerekmektedir.
        </p>
        <button class="btn btn-primary" onclick="document.getElementById('modalBackdrop').classList.remove('active');">
          Tamam, Anladım
        </button>
      </div>
    `;
    backdrop.classList.add('active');
    return;
  }

  modalBody.innerHTML = `
    <h3 style="margin-bottom: 8px; font-size: 1.5rem; color: var(--emerald-dark); text-align: center;">Garson & Hesap Çağır</h3>
    <p style="color: var(--text-muted); font-size: 0.9rem; text-align: center; margin-bottom: 20px;">
      Kilitli Masa: <strong style="color: var(--emerald-main);">${session.tableName}</strong> <span style="font-size: 0.75rem; color: var(--gold-accent);">🔒 Doğrulandı</span>
    </p>

    <div style="display: flex; flex-direction: column; gap: 12px;">
      <button class="btn btn-primary" id="btnCallWaiter" style="padding: 14px;">
        <i class="ri-user-voice-line"></i> Garson Çağır (${session.tableName})
      </button>
      <button class="btn btn-accent" id="btnCallCash" style="padding: 14px;">
        <i class="ri-money-dollar-circle-line"></i> Nakit Hesap İste (${session.tableName})
      </button>
      <button class="btn btn-outline" id="btnCallCard" style="padding: 14px;">
        <i class="ri-bank-card-line"></i> Kredi Kartı POS İste (${session.tableName})
      </button>
    </div>
  `;

  backdrop.classList.add('active');

  const executeCall = (type) => {
    const res = store.addCall(session.tableId, type, false);
    backdrop.classList.remove('active');
    if (res.success) {
      showToast(`✅ ${session.tableName} için ${type === 'waiter' ? 'garson' : 'hesap'} çağrısı iletildi!`);
    } else {
      showSecurityAlertModal(res.error);
    }
  };

  document.getElementById('btnCallWaiter')?.addEventListener('click', () => executeCall('waiter'));
  document.getElementById('btnCallCash')?.addEventListener('click', () => executeCall('cash'));
  document.getElementById('btnCallCard')?.addEventListener('click', () => executeCall('card'));
}

function showSecurityAlertModal(errorMsg) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  modalBody.innerHTML = `
    <div style="text-align: center; padding: 16px 0;">
      <i class="ri-shield-cross-fill" style="font-size: 3.5rem; color: #D9534F; display: block; margin-bottom: 12px;"></i>
      <h3 style="font-size: 1.4rem; color: #D9534F; margin-bottom: 8px;">Güvenlik & Anti-Spoofing Engeli</h3>
      <p style="color: var(--text-dark); font-size: 0.95rem; margin-bottom: 24px; line-height: 1.5;">
        ${errorMsg}
      </p>
      <button class="btn btn-primary" onclick="document.getElementById('modalBackdrop').classList.remove('active');">
        Anladım
      </button>
    </div>
  `;
  backdrop.classList.add('active');
}

/* ==========================================================================
   7. WI-FI PASSWORD COPY & GOOGLE MAPS
   ========================================================================== */
function initWifiCopy() {
  const wifiBtn = document.getElementById('wifiCopyBtn');
  if (!wifiBtn) return;

  wifiBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(store.wifiCode).then(() => {
      showToast(`Wi-Fi Şifresi Panoya Kopyalandı: ${store.wifiCode}`);
    }).catch(() => {
      showToast(`Wi-Fi Şifresi: ${store.wifiCode}`);
    });
  });
}

/* ==========================================================================
   8. SECRET ADMIN TRIGGER (TRIPLE CLICK LOGO)
   ========================================================================== */
function initSecretAdminTrigger() {
  const logos = document.querySelectorAll('.brand-logo');
  logos.forEach(logo => {
    let clickCount = 0;
    let clickTimer;

    logo.addEventListener('click', (e) => {
      e.preventDefault();
      clickCount++;
      clearTimeout(clickTimer);

      if (clickCount >= 3) {
        clickCount = 0;
        window.location.hash = '#secret-admin-gate';
        if (typeof showToast === 'function') {
          showToast('🔑 Gizli Yönetici Giriş Kapısı Açıldı!');
        }
      } else {
        clickTimer = setTimeout(() => {
          if (clickCount === 1) {
            window.location.hash = '#home';
          }
          clickCount = 0;
        }, 300);
      }
    });
  });
}

/* ==========================================================================
   9. UTILITIES & THEME
   ========================================================================== */
function initThemeToggle() {
  const toggleBtn = document.getElementById('themeToggle');
  if (!toggleBtn) return;

  const currentTheme = localStorage.getItem('yesilkose_theme') || 'light';
  document.documentElement.setAttribute('data-theme', currentTheme);
  updateToggleIcon(currentTheme);

  toggleBtn.addEventListener('click', () => {
    const active = document.documentElement.getAttribute('data-theme');
    const newTheme = active === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('yesilkose_theme', newTheme);
    updateToggleIcon(newTheme);
  });

  function updateToggleIcon(theme) {
    const icon = toggleBtn.querySelector('i');
    if (icon) {
      icon.className = theme === 'dark' ? 'ri-sun-line' : 'ri-moon-line';
    }
  }
}

function initMobileMenu() {
  const toggle = document.getElementById('mobileToggle');
  const navLinks = document.querySelector('.nav-links');

  if (!toggle || !navLinks) return;

  toggle.addEventListener('click', () => {
    navLinks.classList.toggle('mobile-open');
  });

  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      navLinks.classList.remove('mobile-open');
    });
  });
}

function initContactForm() {
  const form = document.getElementById('contactForm');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = document.getElementById('formName').value;
    showToast(`Teşekkürler Sayın ${name}! Mesajınız başarıyla iletildi.`);
    form.reset();
  });
}

function showToast(message) {
  let toast = document.getElementById('toastAlert');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'toastAlert';
    toast.style.cssText = `
      position: fixed;
      bottom: 90px;
      right: 30px;
      background: var(--emerald-dark);
      color: var(--gold-hover);
      padding: 16px 24px;
      border-radius: var(--radius-md);
      box-shadow: 0 10px 25px rgba(0,0,0,0.3);
      border: 1px solid var(--gold-accent);
      z-index: 3000;
      font-weight: 600;
      font-size: 0.95rem;
      animation: fadeIn 0.3s ease;
    `;
    document.body.appendChild(toast);
  }
  toast.innerHTML = `<i class="ri-checkbox-circle-fill"></i> ${message}`;
  toast.style.display = 'block';

  setTimeout(() => {
    toast.style.display = 'none';
  }, 4000);
}

function initModal() {
  const backdrop = document.getElementById('modalBackdrop');
  const closeBtn = document.getElementById('modalClose');

  if (closeBtn && backdrop) {
    closeBtn.addEventListener('click', () => {
      backdrop.classList.remove('active');
    });
    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) backdrop.classList.remove('active');
    });
  }
}

function openOrderModal(item) {
  const backdrop = document.getElementById('modalBackdrop');
  const modalBody = document.getElementById('modalBody');
  if (!backdrop || !modalBody) return;

  const session = store.getLockedSession();

  if (!session) {
    showSecurityAlertModal('Sipariş verebilmek için masanızdaki QR kodu cihazınızla taratarak oturum açmanız gerekmektedir.');
    return;
  }

  const hasOptions = item.options && item.options.choices && item.options.choices.length > 0;

  modalBody.innerHTML = `
    <h3 style="margin-bottom: 12px; font-size: 1.5rem; color: var(--emerald-main);">${item.name}</h3>
    <p style="color: var(--text-muted); margin-bottom: 16px;">${item.desc}</p>
    <div style="font-size: 1.3rem; font-weight: 800; color: var(--gold-accent); margin-bottom: 20px;">₺${item.price.toFixed(2)}</div>
    
    <form id="orderForm">
      <div style="background: rgba(19,75,59,0.06); padding: 12px 16px; border-radius: var(--radius-sm); margin-bottom: 16px; font-size: 0.9rem; font-weight: 700; color: var(--emerald-dark);">
        🔒 Doğrulanmış Masa: ${session.tableName}
      </div>

      ${hasOptions ? `
        <div class="form-group" style="margin-bottom: 16px;">
          <label class="form-label">${item.options.title}</label>
          <select id="orderSelectedOption" class="form-input">
            ${item.options.choices.map(c => `<option value="${c}">${c}</option>`).join('')}
          </select>
        </div>
      ` : ''}

      <div class="form-group" style="margin-bottom: 16px;">
        <label class="form-label">Özel Sipariş Notunuz (İsteğe Bağlı)</label>
        <input type="text" id="orderNote" class="form-input" placeholder="Örn: Az şekerli, bol buzlu, açık demli..." maxlength="100">
      </div>

      <div class="form-group">
        <label class="form-label">Adet</label>
        <input type="number" id="orderQty" class="form-input" value="1" min="1" max="20" required>
      </div>
      <button type="submit" class="btn btn-primary w-100" style="width: 100%; margin-top: 12px;">
        <i class="ri-check-double-line"></i> ${session.tableName} Adisyonuna Ekle
      </button>
    </form>
  `;

  backdrop.classList.add('active');

  const orderForm = document.getElementById('orderForm');
  if (orderForm) {
    orderForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const qty = Number(document.getElementById('orderQty').value) || 1;
      const selectedOption = hasOptions ? document.getElementById('orderSelectedOption').value : null;
      const customNote = document.getElementById('orderNote')?.value.trim();

      const combinedOption = [selectedOption, customNote ? `Not: ${customNote}` : null].filter(Boolean).join(' | ');

      const res = store.addItemToAdisyon(session.tableId, item.id, qty, false, combinedOption || null);
      backdrop.classList.remove('active');

      if (res.success) {
        const itemDisplayName = combinedOption ? `${item.name} (${combinedOption})` : item.name;
        showToast(`✅ ${itemDisplayName} (${qty} Adet) ${session.tableName} adisyonuna başarıyla eklendi!`);
      } else {
        showSecurityAlertModal(res.error);
      }
    });
  }
}
